import { TransactionWithDealerRate } from '../../../../../transaction/src/domain/Transaction/entities/TransactionWithDealerRate';
import { MandatePayroll, Mandate } from '../entities';
import PendingAuthorizations from '../entities/PendingAuthorizations';
import PendingAuthorizationsResponseDTO from '../entities/PendingAuthorizationsResponseDTO';

const PendingAuthorizationsResponseDTOtoPendingAuthorizationAdapter = (
  response: PendingAuthorizationsResponseDTO,
): PendingAuthorizations => {
  if (!response.body) {
    throw Error();
  }

  const globalOrders = response.body.globalOrders.map(
    transaction =>
      new TransactionWithDealerRate(
        transaction.customerId,
        transaction.customerDigit,
        transaction.customerSurname,
        transaction.system,
        transaction.accountNumber,
        transaction.accountCode,
        transaction.currencyId,
        transaction.currencyShortDescription,
        transaction.routeGenericDetailDescription,
        transaction.routeGenericDetailShortDescription,
        transaction.routeGenericDetailParameterType,
        transaction.routeGenericDetailSerialNum,
        transaction.orderId,
        transaction.orderCode,
        transaction.orderTrxDate,
        transaction.orderDirection,
        transaction.orderAmount,
        transaction.orderMessageType,
        transaction.beneficiaryName,
        transaction.beneficiaryAccount,
        transaction.beneficiaryIsoCountry,
        transaction.beneficiaryBic,
        transaction.beneficiarySortCode,
        transaction.orderComments,
        transaction.externalIdRef,
        transaction.processType,
        transaction.correspondingAccount,
        transaction.correspondingCustomerId,
        transaction.trxUser,
        transaction.trxUnit,
        transaction.timestamp,
        transaction.orderLogicalKey,
        transaction.financialDate,
        transaction.routingResultDescription,
        transaction.orderValueDate,
        transaction.processingStatus,
        transaction.systemDate,
        transaction.transferDate,
        transaction.beneficiaryBank,
        transaction.status,
      ),
  );

  const mandateResponseList = response.body.mandateResponseList.map(
    authorization =>
      new Mandate(
        authorization.status,
        authorization.account,
        authorization.userId,
        authorization.postingDate,
        authorization.amount,
        authorization.currency,
        authorization.referenceNumber,
        authorization.beneficiaryName,
        authorization.accountId,
        authorization.orderDirection,
        authorization.globalOrderId,
        authorization.orderMessageType,
        authorization.accountNumber,
        authorization.customerId,
        authorization.orderProcessType,
        authorization.processStatus,
        authorization.eligibleForDealerRate,
        authorization.username,
        authorization.transferType,
      ),
  );

  const payrollMandateResponseList = response.body.payrollMandateResponseList.map(
    payrollAuthorization =>
      new MandatePayroll(
        payrollAuthorization.status,
        payrollAuthorization.fromAccount,
        payrollAuthorization.username,
        payrollAuthorization.userId,
        payrollAuthorization.postingDate,
        payrollAuthorization.amount,
        payrollAuthorization.currency,
        payrollAuthorization.referenceNumber,
        payrollAuthorization.beneficiaryName,
        payrollAuthorization.accountId,
        payrollAuthorization.orderDirection,
        payrollAuthorization.globalOrderId,
        payrollAuthorization.orderMessageType,
        payrollAuthorization.accountNumber,
        payrollAuthorization.customerId,
        payrollAuthorization.orderProcessType,
        payrollAuthorization.processStatus,
        payrollAuthorization.fileType,
        payrollAuthorization.fileName,
        payrollAuthorization.payrollFileId,
      ),
  );

  return { globalOrders, payrollMandateResponseList, mandateResponseList };
};

export { PendingAuthorizationsResponseDTOtoPendingAuthorizationAdapter };
